import {
  enumBoxStyleSearch,
  enumHierarchyTypes,
  kBoxStyleRule,
  kPositionBoxStyleRule
} from "../constants";
import { QChartTemplateRule } from "./QChartTemplateRule";

export class QChartTemplate {
  constructor() {
    this.fTemplateID = null;
    this.fTemplateName = null;
    this.fTemplateLibrary = null;
    /**
     * @type {(null | QChartTemplateRule[])}
     */
    this.fRuleList = null;
    this.fHierarchyType = enumHierarchyTypes.employees;
    this.fRootLayout = null;
    this.fDirty = false;
  }

  InitTemplate() {
    this.fRuleList = [];
  }

  /**
   * @returns {number}
   */
  GetNumRules() {
    return this.fRuleList.length;
  }

  /**
   * @param {(number | string)} index
   * @returns {QChartTemplateRule}
   */
  GetIndexRule(index) {
    return this.fRuleList[index];
  }

  SaveToJSON() {
    var output = {};
    output["ID"] = this.fTemplateID;
    output["name"] = this.fTemplateName;
    output["library"] = this.fTemplateLibrary;
    output["hierarchyType"] = this.fHierarchyType;
    output["type"] = "template";

    output["rules"] = [];
    var n = this.GetNumRules();
    for (var i = 0; i < n; i++) {
      var aRule = this.GetIndexRule(i);
      var ruleJSON = aRule.OutputRuleToJSON();
      output["rules"].push(ruleJSON);
    }

    return output;
  }

  LoadFromJSON(theData) {
    this.fTemplateID = theData["ID"];
    this.fTemplateName = theData["name"];
    this.fTemplateLibrary = theData["library"];
    this.fHierarchyType = theData["hierarchyType"] ?? enumHierarchyTypes.employees;
    this.fTemplateSet = theData["templateset"];
    this.SetVisibility(theData["visible"] != null ? theData["visible"] : null);
    this.InitTemplate();
    this.LoadRules(theData);
    //This is for the per connector template set system. Wise use of field IDs can probably mitigate the need for this.
    //var templateSet = theData['set'];
    //if (templateSet)
    //this.fTemplateSet = templateSet;
  }

  LoadRules(theData) {
    var rules = theData["rules"];

    for (var i in rules) {
      var ruleInfo = rules[i];
      var aRule = new QChartTemplateRule();
      //aRule.InitChartTemplateRule();
      aRule.LoadFromJSON(ruleInfo);
      this.fRuleList.push(aRule);
    }
  }

  AddDefaultRule(theBoxStyle) {
    var aRule = new QChartTemplateRule();
    aRule.InitChartTemplateRule();
    aRule.SetRuleCriteria("Always Apply");
    if (theBoxStyle) aRule.SetBoxStyleID(theBoxStyle);
    this.fRuleList.unshift(aRule);
    return aRule;
  }

  SetTemplateName(templateName) {
    this.fTemplateName = templateName;
  }

  GetTemplateName() {
    return this.fTemplateName;
  }

  SetTemplateID(templateID) {
    //Should only happen via automated/hidden systems.
    this.fTemplateID = templateID;
  }

  GetTemplateID() {
    return this.fTemplateID;
  }

  GetVisibility() {
    return this.fIsVisible == true;
  }

  SetVisibility(visibility) {
    this.fIsVisible = visibility;
  }

  SetTemplateLibrary(library) {
    this.fTemplateLibrary = library;
  }

  GetTemplateLibrary() {
    return this.fTemplateLibrary;
  }

  SetHierarchyType(hierarchyType) {
    this.fHierarchyType = hierarchyType;
  }

  GetHierarchyType() {
    return this.fHierarchyType;
  }

  /**
   * @param {string} boxStyleID
   * @returns {boolean}
   */
  UsesBoxStyle(boxStyleID) {
    return this.GetReferencedBoxStyleIDs().has(boxStyleID);
  }

  UsesPhotos(boxStyleMgr) {
    return [...this.GetReferencedBoxStyleIDs()].some(id =>
      boxStyleMgr.GetLayoutByID(id, false, enumBoxStyleSearch.allSets)?.HasPhotoCell()
    );
  }

  /**
   * @returns {Set<string>}
   */
  GetReferencedBoxStyleIDs() {
    var ids = new Set();
    var n = this.GetNumRules();
    for (var i = 0; i < n; i++) {
      var rule = this.GetIndexRule(i);
      var empID = rule.GetBoxStyleID(kBoxStyleRule);
      if (empID != null) ids.add(empID);
      var posID = rule.GetBoxStyleID(kPositionBoxStyleRule);
      if (posID != null) ids.add(posID);
    }
    return ids;
  }

  GetIndexOfRule(aRule) {
    var index = this.fRuleList.indexOf(aRule);
    return index;
  }

  AddRule(aRule) {
    this.fRuleList.push(aRule);
  }

  RemoveRule(aRule) {
    var index = this.fRuleList.indexOf(aRule);
    if (index != -1) this.fRuleList.splice(index, 1);
  }

  ShuffleRule(aRule, shuffleUp, targetIdx) {
    var index = this.GetIndexOfRule(aRule);
    var n = this.GetNumRules();
    var newIndex;

    if (targetIdx != null) newIndex = targetIdx;
    else {
      if (shuffleUp) newIndex = index - 1;
      else newIndex = index + 1;
    }
    if (newIndex < 0) return;
    if (newIndex >= n) return;

    var r = this.fRuleList[newIndex];
    this.fRuleList[newIndex] = aRule;
    this.fRuleList[index] = r;
  }

  Clone() {
    var c = new QChartTemplate();
    c.InitTemplate();
    c.fTemplateID = this.fTemplateID;
    c.fTemplateName = this.fTemplateName;
    c.fTemplateLibrary = this.fTemplateLibrary;
    c.fHierarchyType = this.fHierarchyType;

    var n = this.GetNumRules();
    for (var i = 0; i < n; i++) {
      var aRule = this.GetIndexRule(i);
      var cloneRule = aRule.Clone();
      c.fRuleList.push(cloneRule);
    }

    return c;
  }

  TemplatesMatch(matchTemplate) {
    if (
      matchTemplate.fTemplateID != this.fTemplateID ||
      matchTemplate.fTemplateName != this.fTemplateName
    )
      return false;

    var n = this.GetNumRules();
    var n1 = matchTemplate.GetNumRules();
    if (n != n1) return false;

    for (var i = 0; i < n; i++) {
      var aRule = this.GetIndexRule(i);
      var matchRule = matchTemplate.GetIndexRule(i);
      if (!aRule.RulesMatch(matchRule)) return false;
    }

    return true;
  }

  IsDirty() {
    //I can be dirty from a high level item, or from an individual rule being dirty.
    if (this.fDirty == true) return true;
    for (var ruleIdx in this.fRuleList) {
      var theRule = this.fRuleList[ruleIdx];
      if (theRule.fDirty == true) return true;
    }
    return false;
  }

  SetDirty(doDirty) {
    if (doDirty == true) this.fDirty = true;
    else {
      this.fDirty = false;
      for (var ruleIdx in this.fRuleList) {
        var theRule = this.fRuleList[ruleIdx];
        theRule.fDirty = false;
      }
    }
  }

  GetRootBoxStyleID() {
    //TODO: Support for linked views
    for (var ruleIdx in this.fRuleList) {
      var theRule = this.fRuleList[ruleIdx];
      if (theRule.IsNoRule() && theRule.GetBoxStyleID()) return theRule.GetBoxStyleID();
    }
  }

  UsesMgrGrouping() {
    var n = this.GetNumRules();
    for (var i = 0; i < n; i++) {
      var r = this.GetIndexRule(i);
      if (r.GetApplyToManagers(true) == true) return true;
    }

    return false;
  }
}
